export class UpdateSourceAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "UpdateAwsSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "UpdateAzureSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "UpdateGcpSourceAccountAttributes",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
